import { useState } from 'react';
import StatisticsApiService from '../services/statistics-api.service';
import { useLoading } from './use-loading.hook';
import { LoadingKeys } from '../models/enums/loading-keys.enum';
import {StatisticsResponse} from "../models/interfaces/statistics-dto.interface";

export const useStatisticsApi = () => {
    const loadingKey = LoadingKeys.USE_STATISTICS_API;
    const { startLoading, stopLoading } = useLoading();
    const [error, setError] = useState<string | null>(null);

    const getStatistics = async (): Promise<StatisticsResponse> => {
        startLoading([loadingKey, 'getStatistics']);
        setError(null);
        try {
            return await StatisticsApiService.getStatistics();
        } catch (err: any) {
            setError(err.message);
            throw err;
        } finally {
            stopLoading([loadingKey, 'getStatistics']);
        }
    };

    return {
        error,
        setError,
        getStatistics,
    };
};
